import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider"; // GLOBAL CUSTOM COMPONENTS
import { FlexBetween } from "src/lib/components/salify-next-layout/default/components/flex-box";
import {
  H5,
  H6,
  Paragraph,
} from "src/lib/components/salify-next-layout/default/components/Typography"; // CUSTOM UTILS LIBRARY FUNCTION
import { formatMoney } from "src/lib/utils";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import { ORDER_PAYMENT_LABEL } from "src/lib/fetcher/client";

// ==============================================================
function ListItem({ title, value }) {
  return (
    <FlexBetween mb={1}>
      <Paragraph color="grey.600">{title}</Paragraph>
      <H6>{value || "-"}</H6>
    </FlexBetween>
  );
}

const OrderSummery = ({ order }) => {
  const delivery = order?.orderDelivery;
  const shippingFee = delivery?.shippingFee ?? delivery?.price ?? 0;

  return (
    <Grid container spacing={3}>
      {/* SHIPMENT ADDRESS SECTION */}
      <Grid item lg={6} md={6} xs={12}>
        <Card
          sx={{
            p: 3,
          }}
        >
          <H5 mt={0} mb={2}>
            <SalifyFallback.Label path="Delivery" default="Giao hàng" />
          </H5>

          <SalifyFallback.Label
            path="Receiver:"
            default="Người nhận:"
            render={(label) => <ListItem title={label} value={delivery?.receiver} />}
          />
          <SalifyFallback.Label
            path="Phone:"
            default="Số điện thoại:"
            render={(label) => <ListItem title={label} value={delivery?.contactNumber} />}
          />
          <SalifyFallback.Label
            path="Address:"
            default="Địa chỉ:"
            render={(label) => <ListItem title={label} value={delivery?.address} />}
          />
          <SalifyFallback.Label
            path="Delivery code:"
            default="Mã giao hàng:"
            render={(label) => <ListItem title={label} value={delivery?.code} />}
          />
          <SalifyFallback.Label
            path="Shipping code:"
            default="Mã vận chuyển:"
            render={(label) => <ListItem title={label} value={delivery?.shippingCode} />}
          />
          <SalifyFallback.Label
            path="Shipper:"
            default="Người giao:"
            render={(label) => (
              <ListItem title={label} value={delivery?.shipperName || delivery?.shipperId} />
            )}
          />
        </Card>
      </Grid>

      {/* TOTAL SUMMERY SECTION */}
      <Grid item lg={6} md={6} xs={12}>
        <Card sx={{ p: 3 }}>
          <H5 mt={0} mb={2}>
            <SalifyFallback.Label path="Total Summary" default="Thông tin thanh toán" />
          </H5>

          <SalifyFallback.Label
            path="Subtotal:"
            default="Giá sản phẩm:"
            render={(label) => <ListItem title={label} value={formatMoney(order.totalAmount)} />}
          />

          <SalifyFallback.Label
            path="Shipping fee:"
            default="Phí giao hàng:"
            render={(label) => <ListItem title={label} value={formatMoney(shippingFee)} />}
          />

          <SalifyFallback.Label
            path="Discount:"
            default="Giá giảm:"
            render={(label) => <ListItem title={label} value={formatMoney(order.discount)} />}
          />

          <Divider sx={{ mb: 1 }} />

          <FlexBetween mb={2}>
            <H6>
              <SalifyFallback.Label path="Total" default="Số tiền thanh toán" />
            </H6>
            <H6>{formatMoney(order.totalAmount)}</H6>
          </FlexBetween>

          <Paragraph>{ORDER_PAYMENT_LABEL[order.paymentMethod]}</Paragraph>
        </Card>
      </Grid>
    </Grid>
  );
};

export default OrderSummery;
